// Mock Data for Banks
export const bankData = [
  { name: "Test Institution", url: "stripe.com", color: "#00693E", icon: "🏦" },
  {
    name: "Test OAuth Institution",
    url: "stripe.com",
    color: "#004BA0",
    icon: "🔗",
  },
  {
    name: "Ownership accounts",
    url: "stripe.com",
    color: "#1D9CFF",
    icon: "🔑",
  },
  {
    name: "Sandbox Bank (OAuth)",
    url: "stripe.com",
    color: "#FFC107",
    icon: "📦",
  },
  {
    name: "Sandbox Bank (Non-OAuth)",
    url: "stripe.com",
    color: "#D32F2F",
    icon: "📦",
  },
  {
    name: "Invalid Payment Accounts",
    url: "stripe.com",
    color: "#E91E63",
    icon: "💳",
  },
];
